<template>
  <LinkTemplate :loading="isLoading" :fazenda="fazenda" />
</template>

<script>
import LinkTemplate from "@/components/templates/Link.vue";
import { mapActions } from "vuex";

export default {
  components: { LinkTemplate },
  data: () => ({
    isLoading: false,
    fazenda: null,
  }),
  methods: {
    ...mapActions("properties", ["getLinkAuth"]),
  },
  async mounted() {
    this.isLoading = true;
    if (this.$route.params && this.$route.params.id) {
      const r = await this.getLinkAuth(this.$route.params.id);

      if (r) this.fazenda = r;
    }

    this.isLoading = false;
  },
};
</script>
